import React, { useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import "./multiMenuItem.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import TestImage from "../../../images/test-image.png";
import { faMultiply } from "@fortawesome/free-solid-svg-icons";

import { CSSTransition } from "react-transition-group";
import ShoppingCartIcon from "../../../images/icons/shopping-cart.png";

import { useOrder } from "../../../contexts/OrderContext";

import { useTheme } from "../../../contexts/ThemeContext";

export default function MultiMenuItem({
  open,
  onClose,
  data,
  dropZeros,
  multiMode,
}) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [open]);

  const { addToCart, getMultiTotal, increaseQuantity, decreaseQuantity } =
    useOrder();

  const { theme } = useTheme();

  const multiModeRef = useRef(null);
  const backgroundRef = useRef(null);

  function handleMultiPurchase(mId) {
    const alreadyExist = multiMode.filter(
      (val) => val.ProductMultiModeId === mId
    );

    if (alreadyExist.length !== 0) return;

    const addedOption = data.MultiProductData.filter(
      (val) => val.MultiModeId === mId
    )[0];

    const [price, priceAfterDiscounts] = getMultiTotal(multiMode);

    const item = {
      ProductID: data.ProductId,
      ProductMultiMode: "true",
      ProductTitle: data.ProductTitle,
      ProductPicture: data.ProductPictureUrl,
      Price: price + parseInt(addedOption.Price),
      PriceAfterDiscount:
        priceAfterDiscounts + parseInt(addedOption.PriceAfterDiscount),
      ProductMultiModeDetails: [
        ...multiMode,
        {
          SubTitle: addedOption.MultiModeTitle,
          Price: addedOption.Price,
          PriceAfterDiscount: addedOption.PriceAfterDiscount,
          Quantity: 1,
          ProductMultiModeId: mId,
        },
      ],
    };

    addToCart(item);
  }

  function isInCart(mId) {
    return multiMode.some((val) => val.ProductMultiModeId === mId);
  }

  function getQuantity(mId) {
    const item = multiMode.find((val) => val.ProductMultiModeId === mId);
    return item ? item.Quantity : 0;
  }

  function handleMultiIncrease(mId) {
    increaseQuantity(data.ProductId, mId);
  }

  function handleMultiDecrease(mId) {
    decreaseQuantity(data.ProductId, mId);
  }

  const multiItems = data.MultiProductData.map((val) => (
    <div
      className={`multi-option-item ${
        isInCart(val.MultiModeId) ? "selected-option" : ""
      }`}
      key={val.MultiModeId}
    >
      <div className="option-item-text">
        <h4 className="option-item-name">{val.MultiModeTitle}</h4>
        <p className="option-item-desc">{val.MultiModeTitle}</p>
      </div>
      <div className="option-item-price">
        <span className="option-item-price-num">
          {dropZeros(val.PriceAfterDiscount)}
        </span>
        هزار تومان
      </div>
      <div
        className="option-item-shop"
        onClick={() => handleMultiPurchase(val.MultiModeId)}
      >
        <img src={ShoppingCartIcon} alt="" />
      </div>

      <span className="item-amount multi-option-amount">
        <span
          className="decrease-amount"
          onClick={() =>
            val.Quantity !== 1 ? handleMultiDecrease(val.MultiModeId) : ""
          }
        >
          -
        </span>
        <span className="item-amount-number">
          {getQuantity(val.MultiModeId)}
        </span>
        <span
          className="increase-amount"
          onClick={() => handleMultiIncrease(val.MultiModeId)}
        >
          +
        </span>
      </span>
    </div>
  ));

  return createPortal(
    <>
      <CSSTransition
        nodeRef={backgroundRef}
        in={open}
        timeout={300}
        unmountOnExit
        classNames="popup-background"
      >
        <div
          ref={backgroundRef}
          className="popup-background"
          onMouseDown={(e) => e.stopPropagation()}
        />
      </CSSTransition>
      <CSSTransition
        nodeRef={multiModeRef}
        in={open}
        timeout={300}
        unmountOnExit
        classNames="popup-background"
      >
        <div
          ref={multiModeRef}
          className={`multimenuitem-container ${
            theme === "light" ? "light-mode" : ""
          }`}
          onMouseDown={(e) => e.stopPropagation()}
        >
          <div className="close-button multi-item-mode" onClick={onClose}>
            <FontAwesomeIcon icon={faMultiply} />
          </div>
          <div className="multimenuitem-box">
            <div className="item-box-image">
              <img src={data.ProductPictureUrl} alt="" />
            </div>
            <h2 className="item-box-name">{data.ProductTitle}</h2>
            <div className="multi-menu-options custom-scroll">{multiItems}</div>
          </div>
        </div>
      </CSSTransition>
    </>,
    document.getElementById("popups")
  );
}
